export default "__VITE_ASSET__81cead0d__"